(function () {
    var root = document.querySelector('[data-ukpr-ephemeral]');
    if (!root) return;

    var API_BASE = root.getAttribute('data-api-base') || 'https://pollingreport.uk/api/v1';
    var CAPTURE_MODEL = root.getAttribute('data-capture-model') || 'uniform';
    var PARTY_ORDER = ['lab', 'con', 'reform', 'lib', 'snp', 'green', 'plaid', 'other'];
    var PARTY_LABELS = {
        lab: 'Lab',
        con: 'Con',
        reform: 'Reform',
        lib: 'Lib Dem',
        snp: 'SNP',
        green: 'Green',
        plaid: 'Plaid',
        alba: 'Alba',
        other: 'Other'
    };
    var PARTY_SHORT = {
        lab: 'LAB',
        con: 'CON',
        reform: 'REF',
        lib: 'LD',
        snp: 'SNP',
        green: 'GRN',
        plaid: 'PC',
        other: 'OTH'
    };
    var PARTY_AVATAR_URLS = {
        con: 'https://assets.pollingreport.uk/public/images/ukpr-con-temp.jpg',
        lab: 'https://assets.pollingreport.uk/public/images/ukpr-lab-temp.jpg',
        lib: 'https://assets.pollingreport.uk/public/images/ukpr-lib-temp.jpg',
        snp: 'https://assets.pollingreport.uk/public/images/ukpr-snp-temp.jpg',
        green: 'https://assets.pollingreport.uk/public/images/ukpr-green-temp.jpg',
        reform: 'https://assets.pollingreport.uk/public/images/ukpr-reform-temp.jpg',
        plaid: 'https://assets.pollingreport.uk/public/images/ukpr-plaid-temp.jpg'
    };

    var titleEl = root.querySelector('[data-ephemeral-title]');
    var metaEl = root.querySelector('[data-ephemeral-meta]');
    var loadingEl = root.querySelector('[data-ephemeral-loading]');
    var errorEl = root.querySelector('[data-ephemeral-error]');
    var cardEl = root.querySelector('[data-ephemeral-card]');

    function escHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function fetchJson(url) {
        return fetch(url).then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status + ' for ' + url);
            return res.json();
        });
    }

    function formatDate(value) {
        if (!value) return 'Unknown date';
        var d = new Date(value);
        if (Number.isNaN(d.getTime())) return String(value);
        return d.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    }

    function formatDateCompact(value) {
        if (!value) return '';
        var d = new Date(value);
        if (Number.isNaN(d.getTime())) return String(value);
        return d.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short'
        });
    }

    function formatDateRangeCompact(from, to) {
        if (!from && !to) return 'Unknown';
        if (from && !to) return formatDateCompact(from);
        if (!from && to) return formatDateCompact(to);

        var fromDate = new Date(from);
        var toDate = new Date(to);
        if (Number.isNaN(fromDate.getTime()) || Number.isNaN(toDate.getTime())) {
            return String(from || '') + ' - ' + String(to || '');
        }

        if (fromDate.toDateString() === toDate.toDateString()) {
            return formatDateCompact(fromDate);
        }

        var sameMonth = fromDate.getMonth() === toDate.getMonth() && fromDate.getFullYear() === toDate.getFullYear();
        if (sameMonth) {
            return fromDate.getDate() + ' - ' + toDate.getDate() + ' '
                + toDate.toLocaleDateString('en-GB', { month: 'short' });
        }

        return formatDateCompact(fromDate) + ' - ' + formatDateCompact(toDate);
    }

    function clearBrandLogoWidth() {
        var logoEl = root.querySelector('.ukpr-capture-brand-logo');
        if (!logoEl) return;
        logoEl.style.width = '';
    }

    function buildModelText(opts, extraSmallPrint) {
        var genDate = opts && opts.generated ? new Date(opts.generated) : new Date();
        var modelText = 'MODEL: UKPR ' + String(opts.model || CAPTURE_MODEL).toUpperCase()
            + ' | generated ' + formatDate(genDate);
        if (extraSmallPrint && extraSmallPrint.length) {
            modelText += ' | ' + extraSmallPrint.join(' | ');
        }
        return modelText;
    }

    function buildInlineBrand(opts, extraSmallPrint) {
        var brandLogoEl = root.querySelector('.ukpr-capture-brand-logo');
        var brandTextEl = root.querySelector('.ukpr-capture-brand-text');
        var modelText = buildModelText(opts, extraSmallPrint);
        if (brandLogoEl) {
            return '<div class="ukpr-poll-capture-logo">'
                + '<img src="' + escHtml(brandLogoEl.src) + '" alt="' + escHtml(brandLogoEl.alt) + '">'
                + '<p class="ukpr-poll-capture-model">' + escHtml(modelText) + '</p>'
                + '</div>';
        } else if (brandTextEl) {
            return '<div class="ukpr-poll-capture-logo">'
                + '<span class="ukpr-capture-brand-text">' + escHtml(brandTextEl.textContent) + '</span>'
                + '<p class="ukpr-poll-capture-model">' + escHtml(modelText) + '</p>'
                + '</div>';
        }
        return '';
    }


    /**
     * Fit bar rows inside a panel by computing a slot height and setting CSS
     * custom properties on the panel element.
     *
     * opts:
     *   hasAvatar  {boolean} — whether rows have circular avatar images (default true)
     *   minSlot    {number}  — minimum slot height in px before we consider trimming (default 40)
     *   maxSlot    {number}  — maximum slot height in px (default 110)
     */
    function fitBarPanel(panelEl, barCount, opts) {
        if (!panelEl || barCount < 1) return;
        opts = opts || {};
        var hasAvatar = opts.hasAvatar !== false;
        var minSlot   = opts.minSlot || 40;
        var maxSlot   = opts.maxSlot || 110;

        var rect = panelEl.getBoundingClientRect();
        var paddingV = parseFloat(getComputedStyle(panelEl).paddingTop || '0')
                     + parseFloat(getComputedStyle(panelEl).paddingBottom || '0');
        var availH = Math.max(0, rect.height - paddingV);
        var slotH  = Math.min(maxSlot, Math.max(minSlot, Math.floor(availH / barCount)));

        // Derived sizes (px) — avatar capped at slotH-12 to guarantee 6px clearance between rows
        var avatarPx  = hasAvatar ? Math.round(Math.min(80, Math.max(26, Math.min(slotH - 12, slotH * 0.78)))) : 0;
        var trackPx   = Math.round(Math.min(36, Math.max(14, slotH * (hasAvatar ? 0.38 : 0.55))));
        // column width = avatar + overlap offset + a small buffer
        var colPx     = hasAvatar ? (avatarPx + 4) : Math.round(Math.min(60, Math.max(32, slotH * 0.6)));
        // value font in rem (divide by 10)
        var valueSizeRem = (Math.min(2.2, Math.max(1.0, +(slotH * 0.024).toFixed(2)))).toFixed(1);

        panelEl.style.setProperty('--bar-avatar',     avatarPx + 'px');
        panelEl.style.setProperty('--bar-track',      trackPx + 'px');
        panelEl.style.setProperty('--bar-col-avatar', colPx + 'px');
        panelEl.style.setProperty('--bar-value-size', valueSizeRem + 'rem');
    }

    /**
     * Binary-search the font-size of headingEl (in px) until its content fits
     * within containerEl without overflow, between minPx and maxPx.
     */
    function fitTextToPanel(headingEl, containerEl, maxPx, minPx) {
        if (!headingEl || !containerEl) return;
        // Reset to max first
        headingEl.style.fontSize = maxPx + 'px';
        if (headingEl.scrollHeight <= containerEl.clientHeight
            && headingEl.scrollWidth <= containerEl.clientWidth) return; // already fits

        var lo = minPx, hi = maxPx, mid;
        for (var i = 0; i < 16; i++) { // max 16 iterations
            mid = Math.floor((lo + hi) / 2);
            headingEl.style.fontSize = mid + 'px';
            var fits = headingEl.scrollHeight <= containerEl.clientHeight
                    && headingEl.scrollWidth  <= containerEl.clientWidth;
            if (fits) { lo = mid; } else { hi = mid - 1; }
            if (lo >= hi) break;
        }
        headingEl.style.fontSize = lo + 'px';
    }

    /**
     * Trim partyData array (sorted descending) so bars won't be too small,
     * keeping at least minKeep rows and never removing protected keys.
     */
    var MIN_SLOT_PX = 40;
    function trimPartyData(partyData, panelAvailH, minKeep, protectedKeys) {
        minKeep = minKeep || 2;
        protectedKeys = protectedKeys || [];
        var n = partyData.length;
        while (n > minKeep && Math.floor(panelAvailH / n) < MIN_SLOT_PX) {
            // Drop from the bottom unless it's a protected key
            var dropped = false;
            for (var i = n - 1; i >= minKeep; i--) {
                if (protectedKeys.indexOf(partyData[i].key) === -1) {
                    partyData.splice(i, 1);
                    n = partyData.length;
                    dropped = true;
                    break;
                }
            }
            if (!dropped) break; // all remaining are protected
        }
        return partyData;
    }

    function normalizeType(rawType) {
        var input = String(rawType || '').toLowerCase().replace(/^\/+/, '').trim();
        if (input.indexOf('/') !== -1) input = input.split('/')[0];
        if (input === 'party' || input === 'parties') return 'party';
        if (input === 'poll' || input === 'polls') return 'poll';
        if (input === 'result' || input === 'results') return 'result';
        if (input === 'seat' || input === 'seats') return 'seat';
        if (input === 'map' || input === 'maps') return 'map';
        if (input === 'projection' || input === 'race-to-326' || input === 'race' || input === 'projection-card') return 'projection';
        if (input === 'polls-latest' || input === 'polls-summary' || input === 'latest-polls') return 'polls-latest';
        if (input === 'polls-chart' || input === 'polls-trend' || input === 'vote-chart') return 'polls-chart';
        if (input === 'seats-chart' || input === 'seats-trend' || input === 'projections-chart' || input === 'projection-chart') return 'seats-chart';
        return 'seat';
    }

    function parseRequestedState() {
        var params = new URLSearchParams(window.location.search);

        // Always use the LAST occurrence of a param: if the screenshot service
        // appended variables after a base URL that already contained stale params,
        // the appended (later) values represent the actual intent and should win.
        function lastParam() {
            var names = Array.prototype.slice.call(arguments);
            for (var i = 0; i < names.length; i++) {
                var all = params.getAll(names[i]);
                if (all.length) return all[all.length - 1];
            }
            return null;
        }

        var routeHint = lastParam('path', 'route') || '';
        var pathParts = routeHint.replace(/^\/+/, '').split('/').filter(Boolean);

        var type = normalizeType(lastParam('type', 'kind') || pathParts[0] || 'seats');
        var id = lastParam('id', 'uuid') || '';
        var code = (lastParam('code', 'seat', 'constituency') || '').toUpperCase();
        var slug = lastParam('slug', 'party') || '';

        if (!id && pathParts.length >= 2) {
            if (type === 'poll' || type === 'result') id = pathParts[1];
            if (type === 'party') slug = pathParts[1];
            if (type === 'seat' || type === 'map') code = pathParts[1].toUpperCase();
        }

        var rawW = parseInt(lastParam('w', 'width') || '1200', 10);
        var rawH = parseInt(lastParam('h', 'height') || '630', 10);

        return {
            type: type,
            id: id,
            code: code,
            slug: slug,
            model: CAPTURE_MODEL,
            boundaries: lastParam('boundaries') || '2024',
            width: rawW > 0 ? rawW : 1200,
            height: rawH > 0 ? rawH : 630,
            w: rawW > 0 ? rawW : 1200,
            h: rawH > 0 ? rawH : 630,
            generated: lastParam('generated', 'generated_at', 'generatedAt', 'generated_at_utc') || null
        };
    }

    function setStateLoading() {
        document.documentElement.removeAttribute('data-capture-ready');
        loadingEl.hidden = false;
        errorEl.hidden = true;
        cardEl.hidden = true;
    }

    function setStateError(message) {
        loadingEl.hidden = true;
        errorEl.hidden = false;
        cardEl.hidden = true;
        errorEl.textContent = message;
    }

    function setStateReady() {
        loadingEl.hidden = true;
        errorEl.hidden = true;
        cardEl.hidden = false;
    }

    function signalReady() {
        document.documentElement.setAttribute('data-capture-ready', 'true');
    }

    /**
     * Wait for all <img> elements inside containerEl to finish loading
     * (or error), then call signalReady(). Falls back after 8 s so a
     * broken image URL can never stall the screenshot indefinitely.
     */
    function waitImagesAndSignal(containerEl) {
        var imgs = Array.prototype.slice.call((containerEl || document).querySelectorAll('img'));
        var pending = imgs.filter(function (img) {
            return !(img.complete && img.naturalWidth > 0);
        });

        if (!pending.length) {
            signalReady();
            return;
        }

        var resolved = 0;
        var total = pending.length;
        var done = false;

        function tick() {
            resolved += 1;
            if (!done && resolved >= total) {
                done = true;
                clearTimeout(timeout);
                signalReady();
            }
        }

        // Safety timeout — signal anyway after 8 s
        var timeout = setTimeout(function () {
            if (!done) { done = true; signalReady(); }
        }, 8000);

        pending.forEach(function (img) {
            function onLoad() {
                img.removeEventListener('load', onLoad);
                img.removeEventListener('error', onErr);
                tick();
            }
            function onErr() {
                img.removeEventListener('load', onLoad);
                img.removeEventListener('error', onErr);
                tick();
            }
            img.addEventListener('load', onLoad);
            img.addEventListener('error', onErr);
            // Double-check: might have completed between the filter and now
            if (img.complete) {
                img.removeEventListener('load', onLoad);
                img.removeEventListener('error', onErr);
                tick();
            }
        });
    }

    function partyRow(label, value, partyKey) {
        return '<div class="ukpr-ephemeral-row">'
            + '<span class="ukpr-ephemeral-party party-' + escHtml(partyKey) + '">' + escHtml(label) + '</span>'
            + '<span class="ukpr-ephemeral-value">' + escHtml(value) + '</span>'
            + '</div>';
    }

    function getSeatAvatarUrl(seat, key, incumbent) {
        var mp = seat.constituency && seat.constituency.mp;
        var mpParty = mp && (
            (mp.party && (mp.party.stub || mp.party.slug)) || mp.party_slug || ''
        );
        if (typeof mpParty === 'string') mpParty = mpParty.toLowerCase();

        // Build candidates-by-party map
        var candidatesByParty = {};
        var candidateList = (Array.isArray(seat.candidates) && seat.candidates)
            || (seat.constituency && Array.isArray(seat.constituency.candidates) && seat.constituency.candidates)
            || [];
        candidateList.forEach(function (c) {
            var stub = (c.party && (c.party.stub || c.party.slug)) || c.party_slug || '';
            if (stub) candidatesByParty[stub.toLowerCase()] = c;
        });

        // MP photo takes priority when their party matches and they're not standing down
        if (mp && mpParty === key && !mp.standing_down && mp.thumbnail_url) {
            return mp.thumbnail_url;
        }
        var candidate = candidatesByParty[key];
        if (candidate && candidate.thumbnail_url) {
            return candidate.thumbnail_url;
        }
        if (key === 'other' && candidatesByParty.ind && candidatesByParty.ind.thumbnail_url) {
            return candidatesByParty.ind.thumbnail_url;
        }
        if (key === incumbent && mp && !mp.standing_down && mpParty === incumbent && mp.thumbnail_url) {
            return mp.thumbnail_url;
        }
        return PARTY_AVATAR_URLS[key] || '';
    }

    function renderSeat(seat, opts) {
        var winner = String(seat.winner || '').toLowerCase();
        var incumbent = String(seat.incumbent || '').toLowerCase();
        var winnerLabel = PARTY_LABELS[winner] || winner.toUpperCase() || 'N/A';
        var incumbentLabel = PARTY_LABELS[incumbent] || (seat.incumbent || '').toUpperCase();
        var constituencyName = seat.constituency_name || seat.constituency_code || 'Seat';
        var region = seat.region || '';
        var country = seat.country || '';
        var contextParts = [region, country].filter(Boolean);
        var majorityText = seat.majority ? 'Majority: ' + seat.majority : '';

        var isHold = winner && winner === incumbent;
        var statusHtml = isHold
            ? '<span class="party-' + escHtml(winner) + '">' + escHtml(winnerLabel.toUpperCase()) + '</span>'
              + ' <span class="ukpr-seat-capture-winner-muted">PROJECTED</span>'
              + ' <span class="party-' + escHtml(winner) + '">HOLD</span>'
            : '<span class="party-' + escHtml(winner) + '">' + escHtml(winnerLabel.toUpperCase()) + '</span>'
              + ' <span class="ukpr-seat-capture-winner-muted">PROJECTED GAIN FROM</span>'
              + ' <span class="party-' + escHtml(incumbent) + '">' + escHtml(incumbentLabel.toUpperCase()) + '</span>';

        var partyData = PARTY_ORDER.map(function (key) {
            return {
                key: key,
                label: PARTY_LABELS[key] || key.toUpperCase(),
                value: Number(seat[key] || 0)
            };
        }).filter(function (p) { return p.value > 0; })
          .sort(function (a, b) { return b.value - a.value; });

        // Pre-render trim: estimate available panel height
        var frameH = Math.round(opts.height * 0.97);
        var estRightH = frameH - 102; // subtract frame padding + brand footer
        partyData = trimPartyData(partyData, estRightH, 2, [winner, incumbent]);

        var top = partyData[0] || { key: 'other', label: 'Other', value: 0 };
        var graphRailMax = Math.max(5, top.value + 5);

        var avatarUrl, avatar, fillWidth;
        var bars = partyData.map(function (party) {
            fillWidth = Math.max(0, Math.min(100, (party.value / graphRailMax) * 100));
            var value = party.value.toFixed(1).replace(/\.0$/, '');
            avatarUrl = getSeatAvatarUrl(seat, party.key, incumbent);
            avatar = avatarUrl
                ? '<img src="' + escHtml(avatarUrl) + '" alt="' + escHtml(party.label) + '" class="ukpr-poll-bar-avatar-img">'
                : '<span class="ukpr-poll-bar-avatar-fallback">' + escHtml(PARTY_SHORT[party.key] || party.label.toUpperCase()) + '</span>';
            return ''
                + '<div class="ukpr-poll-bar-row">'
                + '<span class="ukpr-poll-bar-avatar party-' + escHtml(party.key) + '">' + avatar + '</span>'
                + '<div class="ukpr-poll-bar-track">'
                + '<div class="ukpr-poll-bar-fill party-' + escHtml(party.key) + '" style="width:' + escHtml(String(fillWidth)) + '%"></div>'
                + '</div>'
                + '<span class="ukpr-poll-bar-value party-' + escHtml(party.key) + '">' + escHtml(value) + '%</span>'
                + '</div>';
        }).join('');

        titleEl.textContent = '';
        metaEl.textContent = 'Type: /seats | Code: ' + (seat.constituency_code || opts.code || 'auto')
            + ' | Model: ' + opts.model + ' | Winner: ' + (PARTY_LABELS[winner] || winner.toUpperCase() || 'N/A');

        var barCount = partyData.length;
        var inlineLogo = buildInlineBrand(opts);

        cardEl.innerHTML = ''
            + '<div class="ukpr-seat-capture-layout">'
            + '<section class="ukpr-seat-capture-left">'
            + '<p class="ukpr-seat-capture-kicker">Constituency Projection</p>'
            + '<h2 class="ukpr-seat-capture-name">' + escHtml(constituencyName) + '</h2>'
            + '<p class="ukpr-seat-capture-winner">' + statusHtml + '</p>'
            + (contextParts.length ? '<p class="ukpr-seat-capture-context">' + escHtml(contextParts.join(' · ')) + '</p>' : '')
            + (majorityText ? '<p class="ukpr-seat-capture-context">' + escHtml(majorityText) + '</p>' : '')
            + inlineLogo
            + '</section>'
            + '<section class="ukpr-seat-capture-right" aria-label="Party vote share bar chart">'
            + bars
            + '</section>'
            + '</div>';
        requestAnimationFrame(function () {
            var rightPanel = cardEl.querySelector('.ukpr-seat-capture-right');
            var nameEl = cardEl.querySelector('.ukpr-seat-capture-name');
            var leftPanel = cardEl.querySelector('.ukpr-seat-capture-left');
            fitBarPanel(rightPanel, barCount, { hasAvatar: true });
            fitTextToPanel(nameEl, leftPanel, 48, 22);
            waitImagesAndSignal(cardEl);
        });
    }

    function renderPoll(poll, opts) {
        var partyData = PARTY_ORDER.map(function (key) {
            return {
                key: key,
                label: PARTY_LABELS[key] || key.toUpperCase(),
                value: Number(poll[key] || 0)
            };
        }).filter(function (p) { return p.value > 0; })
          .sort(function (a, b) { return b.value - a.value; });

        // Pre-render trim
        var frameH = Math.round(opts.height * 0.97);
        var estRightH = frameH - 102;
        var topKey = partyData.length ? partyData[0].key : '';
        partyData = trimPartyData(partyData, estRightH, 2, [topKey]);

        var top = partyData[0] || { key: 'other', label: 'Other', value: 0 };
        var second = partyData[1] || { key: 'other', label: 'Other', value: 0 };
        var leadPoints = Math.max(0, top.value - second.value);
        var leadValue = leadPoints.toFixed(1).replace(/\.0$/, '') + '%';
        var graphRailMax = Math.max(5, top.value + 5);

        var bars = partyData.map(function (party) {
            var value = party.value.toFixed(1).replace(/\.0$/, '');
            var fillWidth = Math.max(0, Math.min(100, (party.value / graphRailMax) * 100));
            var avatarUrl = PARTY_AVATAR_URLS[party.key] || '';
            var avatar = avatarUrl
                ? '<img src="' + escHtml(avatarUrl) + '" alt="' + escHtml(party.label) + '" class="ukpr-poll-bar-avatar-img">'
                : '<span class="ukpr-poll-bar-avatar-fallback">' + escHtml(PARTY_SHORT[party.key] || party.label.toUpperCase()) + '</span>';
            return ''
                + '<div class="ukpr-poll-bar-row">'
                + '<span class="ukpr-poll-bar-avatar party-' + escHtml(party.key) + '">' + avatar + '</span>'
                + '<div class="ukpr-poll-bar-track">'
                + '<div class="ukpr-poll-bar-fill party-' + escHtml(party.key) + '" style="width:' + escHtml(String(fillWidth)) + '%"></div>'
                + '</div>'
                + '<span class="ukpr-poll-bar-value party-' + escHtml(party.key) + '">' + escHtml(value) + '%</span>'
                + '</div>';
        }).join('');

        var pollsterName = (poll.pollster && poll.pollster.name) ? poll.pollster.name : 'Latest poll';
        var clientName = (poll.client && poll.client.name) ? poll.client.name : '';
        var clientLine = clientName
            ? '<p class="ukpr-poll-capture-client">Client: ' + escHtml(clientName) + '</p>'
            : '';

        titleEl.textContent = '';
        metaEl.textContent = 'Type: /polls | ID: ' + (poll.id || opts.id || 'latest')
            + ' | Fieldwork: ' + formatDate(poll.from) + ' to ' + formatDate(poll.to)
            + ' | Winner: ' + (top.label || 'N/A');

        var barCount = partyData.length;
        var inlineLogo = buildInlineBrand(opts);

        cardEl.innerHTML = ''
            + '<div class="ukpr-poll-capture-layout">'
            + '<section class="ukpr-poll-capture-left">'
            + '<p class="ukpr-poll-capture-range">NEW POLL: ' + escHtml(formatDateRangeCompact(poll.from, poll.to)) + '</p>'
            + '<h2 class="ukpr-poll-capture-pollster">' + escHtml(pollsterName) + '</h2>'
            + clientLine
            + '<p class="ukpr-poll-capture-lead">'
            + '<span class="ukpr-poll-capture-lead-party party-' + escHtml(top.key) + '">' + escHtml(top.label.toUpperCase()) + ' LEAD</span> '
            + '<span class="ukpr-poll-capture-lead-value">' + escHtml(leadValue) + '</span>'
            + '</p>'
            + inlineLogo
            + '</section>'
            + '<section class="ukpr-poll-capture-right" aria-label="Party support bar graph">'
            + bars
            + '</section>'
            + '</div>';

        requestAnimationFrame(function () {
            var rightPanel = cardEl.querySelector('.ukpr-poll-capture-right');
            var pollsterEl = cardEl.querySelector('.ukpr-poll-capture-pollster');
            var leftPanel = cardEl.querySelector('.ukpr-poll-capture-left');
            fitBarPanel(rightPanel, barCount, { hasAvatar: true });
            fitTextToPanel(pollsterEl, leftPanel, 61, 24);
            waitImagesAndSignal(cardEl);
        });
    }

    function renderResult(result, opts) {
        var winner = String((result.lead && result.lead.winner) || '').toLowerCase();
        var pollsterName = (result.poll && result.poll.pollster && result.poll.pollster.name) ? result.poll.pollster.name : 'Model';
        var dateRange = formatDateRangeCompact(result.poll && result.poll.from, result.poll && result.poll.to);
        var boundaries = String(result.boundaries || opts.boundaries || '2024');

        // Build seat data sorted by prediction descending, other last
        var seatData = PARTY_ORDER.map(function (key) {
            var party = result.parties && result.parties[key] ? result.parties[key] : null;
            return {
                key: key,
                label: PARTY_LABELS[key] || key.toUpperCase(),
                seats: party && party.seats ? Number(party.seats.prediction) : 0,
                vote: party && party.vote ? Number(party.vote.prediction) : 0
            };
        });
        seatData.sort(function (a, b) {
            if (a.key === 'other') return 1;
            if (b.key === 'other') return -1;
            return b.seats - a.seats;
        });
        // Filter to parties with at least 1 seat
        seatData = seatData.filter(function (p) { return p.seats > 0; });

        // Pre-render trim
        var frameH = Math.round(opts.height * 0.97);
        var estRightH = frameH - 102;
        seatData = trimPartyData(seatData, estRightH, 2, [winner]);

        var topSeats = seatData[0] ? seatData[0].seats : 1;
        var railMax = Math.max(topSeats + 20, 350);
        // majority marker as % of rail
        var majorityPct = Math.min(100, (326 / railMax) * 100).toFixed(2);
        var avatarUrl, avatar, fillWidth;

        var bars = seatData.map(function (party) {
            fillWidth = Math.max(0, Math.min(100, (party.seats / railMax) * 100));
            avatarUrl = PARTY_AVATAR_URLS[party.key] || '';
            avatar = avatarUrl
                ? '<img src="' + escHtml(avatarUrl) + '" alt="' + escHtml(party.label) + '" class="ukpr-result-bar-avatar-img">'
                : '<span class="ukpr-result-bar-avatar-fallback">' + escHtml(PARTY_SHORT[party.key] || party.label.toUpperCase()) + '</span>';
            return ''
                + '<div class="ukpr-result-bar-row">'
                + '<span class="ukpr-result-bar-avatar party-' + escHtml(party.key) + '">' + avatar + '</span>'
                + '<div class="ukpr-result-bar-track-wrap">'
                + '<div class="ukpr-result-bar-track">'
                + '<div class="ukpr-result-bar-fill party-' + escHtml(party.key) + '" style="width:' + escHtml(String(fillWidth)) + '%"></div>'
                + '</div>'
                + '<div class="ukpr-result-bar-majority" style="left:' + escHtml(String(majorityPct)) + '%"></div>'
                + '</div>'
                + '<span class="ukpr-result-bar-value party-' + escHtml(party.key) + '">'
                + escHtml(String(party.seats))
                + '<small>' + escHtml(party.vote.toFixed(1).replace(/\.0$/, '')) + '%</small>'
                + '</span>'
                + '</div>';
        }).join('');

        titleEl.textContent = '';
        metaEl.textContent = 'Type: /results | ID: ' + (result.id || opts.id || 'latest')
            + ' | Model: ' + opts.model
            + ' | Winner: ' + (PARTY_LABELS[winner] || winner.toUpperCase() || 'N/A')
            + ' | Lead: ' + escHtml(String((result.lead && result.lead.points) || 'N/A'));

        var barCount = seatData.length;
        cardEl.innerHTML = ''
            + '<div class="ukpr-result-capture-layout">'
            + '<section class="ukpr-result-capture-left">'
            + '<p class="ukpr-result-capture-kicker">Seat Projection</p>'
            + '<h2 class="ukpr-result-capture-pollster">' + escHtml(pollsterName) + '</h2>'
            + '<p class="ukpr-result-capture-dates">' + escHtml(dateRange) + '</p>'
            + '<p class="ukpr-result-capture-majority">326 seats for majority</p>'
            + '<p class="ukpr-result-capture-majority">Boundaries: ' + escHtml(boundaries) + '</p>'
            + buildInlineBrand(opts)
            + '</section>'
            + '<section class="ukpr-result-capture-right" aria-label="Seat projection bar chart">'
            + bars
            + '</section>'
            + '</div>';
        requestAnimationFrame(function () {
            var rightPanel = cardEl.querySelector('.ukpr-result-capture-right');
            var pollsterEl = cardEl.querySelector('.ukpr-result-capture-pollster');
            var leftPanel = cardEl.querySelector('.ukpr-result-capture-left');
            fitBarPanel(rightPanel, barCount, { hasAvatar: true });
            fitTextToPanel(pollsterEl, leftPanel, 61, 24);
            waitImagesAndSignal(cardEl);
        });
    }

    function renderParty(party, result, opts) {
        var key = String(party.stub || party.slug || '').toLowerCase();
        var metrics = result && result.parties ? result.parties[key] : null;
        var seats = metrics && metrics.seats ? Number(metrics.seats.prediction) : 0;
        var vote = metrics && metrics.vote ? Number(metrics.vote.prediction) : 0;
        var change = metrics && metrics.seats ? Number(metrics.seats.change) : null;

        var changeStr = change === null ? 'N/A' : (change > 0 ? '+' + change : String(change));
        var changeClass = change === null ? 'is-neutral' : (change > 0 ? 'is-positive' : (change < 0 ? 'is-negative' : 'is-neutral'));

        // Build all-party seat bars, focal party highlighted
        var seatData = PARTY_ORDER.map(function (k) {
            var p = result && result.parties && result.parties[k] ? result.parties[k] : null;
            return {
                key: k,
                label: PARTY_SHORT[k] || k.toUpperCase(),
                seats: p && p.seats ? Number(p.seats.prediction) : 0
            };
        });
        seatData.sort(function (a, b) {
            if (a.key === 'other') return 1;
            if (b.key === 'other') return -1;
            return b.seats - a.seats;
        });
        // Filter to parties with seats; always keep focal
        seatData = seatData.filter(function (p) { return p.seats > 0 || p.key === key; });

        // Pre-render trim for party bars
        var frameH = Math.round(opts.height * 0.97);
        var estBarsH = Math.max(80, frameH - 102 - 130 - 100 - 32); // frame overhead + header + metrics + gaps
        seatData = trimPartyData(seatData, estBarsH, 2, [key]);

        var topSeats = seatData[0] ? seatData[0].seats : 1;
        var railMax = Math.max(topSeats + 20, 350);
        var majorityPct = Math.min(100, (326 / railMax) * 100).toFixed(2);

        var bars = seatData.map(function (p) {
            var fillWidth = Math.max(0, Math.min(100, (p.seats / railMax) * 100));
            var isFocal = p.key === key;
            return ''
                + '<div class="ukpr-party-bar-row' + (isFocal ? ' is-focal' : '') + '">'
                + '<span class="ukpr-party-bar-label party-' + escHtml(p.key) + '">' + escHtml(p.label) + '</span>'
                + '<div class="ukpr-party-bar-track-wrap">'
                + '<div class="ukpr-party-bar-track">'
                + '<div class="ukpr-party-bar-fill party-' + escHtml(p.key) + '" style="width:' + escHtml(String(fillWidth)) + '%"></div>'
                + '</div>'
                + '<div class="ukpr-party-bar-majority" style="left:' + escHtml(String(majorityPct)) + '%"></div>'
                + '</div>'
                + '<span class="ukpr-party-bar-value party-' + escHtml(p.key) + '">' + escHtml(String(p.seats)) + '</span>'
                + '</div>';
        }).join('');

        titleEl.textContent = '';
        metaEl.textContent = 'Type: /parties | Slug: ' + escHtml(party.slug || opts.slug || 'auto')
            + ' | Model: ' + opts.model
            + ' | Seats: ' + seats + ' | Vote: ' + vote + '%';

        var partyAvatarUrl = PARTY_AVATAR_URLS[key] || '';
        var partyAvatarHtml = partyAvatarUrl
            ? '<img src="' + escHtml(partyAvatarUrl) + '" alt="' + escHtml(party.name || key) + '">'
            : '<span class="ukpr-party-capture-header-avatar-fallback party-' + escHtml(key) + '">' + escHtml(PARTY_SHORT[key] || key.toUpperCase()) + '</span>';

        var barCount = seatData.length;
        cardEl.innerHTML = ''
            + '<div class="ukpr-party-capture-layout">'
            + '<header class="ukpr-party-capture-header party-' + escHtml(key) + '">'
            + '<span class="ukpr-party-capture-header-avatar party-' + escHtml(key) + '">' + partyAvatarHtml + '</span>'
            + '<div class="ukpr-party-capture-header-text">'
            + '<h2 class="ukpr-party-capture-name party-' + escHtml(key) + '">' + escHtml(party.name || key.toUpperCase()) + '</h2>'
            + '<p class="ukpr-party-capture-sub">Modelled seat projection</p>'
            + '</div>'
            + '</header>'
            + '<div class="ukpr-party-capture-metrics">'
            + '<div class="ukpr-party-capture-metric">'
            + '<span class="ukpr-party-capture-metric-value party-' + escHtml(key) + '">' + escHtml(String(seats)) + '</span>'
            + '<span class="ukpr-party-capture-metric-label">Seats</span>'
            + '</div>'
            + '<div class="ukpr-party-capture-metric">'
            + '<span class="ukpr-party-capture-metric-value party-' + escHtml(key) + '">' + escHtml(vote.toFixed(1).replace(/\.0$/, '')) + '%</span>'
            + '<span class="ukpr-party-capture-metric-label">Vote share</span>'
            + '</div>'
            + '<div class="ukpr-party-capture-metric">'
            + '<span class="ukpr-party-capture-metric-value ' + escHtml(changeClass) + '">' + escHtml(changeStr) + '</span>'
            + '<span class="ukpr-party-capture-metric-label">Seat change</span>'
            + '</div>'
            + '</div>'
            + '<div class="ukpr-party-capture-bars" aria-label="All-party seat projection">'
            + bars
            + '</div>'
            + '</div>';
        requestAnimationFrame(function () {
            var barsPanel = cardEl.querySelector('.ukpr-party-capture-bars');
            var nameEl = cardEl.querySelector('.ukpr-party-capture-name');
            var headerEl = cardEl.querySelector('.ukpr-party-capture-header');
            fitBarPanel(barsPanel, barCount, { hasAvatar: false, maxSlot: 70 });
            fitTextToPanel(nameEl, headerEl, 60, 28);
            syncBrandLogoToPanel(null);
            waitImagesAndSignal(cardEl);
        });
    }

    function fetchSeat(opts) {
        var url = API_BASE + '/seats?paginate=true&per_page=1&verbose=true&model=' + encodeURIComponent(opts.model);
        if (opts.code) url += '&search=' + encodeURIComponent(opts.code);
        return fetchJson(url).then(function (json) {
            if (!json.data || !json.data.length) throw new Error('No seat found. Provide ?code=E14001169 or any constituency code.');
            return json.data[0];
        });
    }

    function fetchPoll(opts) {
        var url = API_BASE + '/polls?paginate=true&per_page=1';
        if (opts.id) url += '&id=' + encodeURIComponent(opts.id);
        return fetchJson(url).then(function (json) {
            if (!json.data || !json.data.length) throw new Error('No poll found. Provide ?id=<poll_uuid> or omit for latest.');
            return json.data[0];
        });
    }

    function fetchResult(opts) {
        var legacy = opts.boundaries === '2019' ? 'true' : 'false';
        var url = API_BASE + '/results?paginate=true&per_page=1&model=' + encodeURIComponent(opts.model) + '&legacy=' + legacy;
        if (opts.id) url += '&id=' + encodeURIComponent(opts.id);
        return fetchJson(url).then(function (json) {
            if (!json.data || !json.data.length) throw new Error('No result found. Provide ?id=<result_uuid> or omit for latest.');
            return json.data[0];
        });
    }

    function fetchParty(opts) {
        return fetchJson(API_BASE + '/parties?paginate=true&per_page=120').then(function (json) {
            if (!json.data || !json.data.length) throw new Error('No parties returned from API.');

            var wanted = String(opts.slug || '').toLowerCase();
            var party = json.data[0];

            if (wanted) {
                party = json.data.find(function (p) {
                    return String(p.slug || '').toLowerCase() === wanted
                        || String(p.stub || '').toLowerCase() === wanted
                        || String(p.name || '').toLowerCase() === wanted;
                });
            }

            if (!party) throw new Error('No party matched "' + wanted + '".');
            return party;
        });
    }

    function fetchProjection(opts) {
        var legacy = opts.boundaries === '2019' ? 'true' : 'false';
        return fetchJson(API_BASE + '/results?paginate=true&per_page=1&model=' + encodeURIComponent(opts.model) + '&legacy=' + legacy)
            .then(function (json) {
                if (!json.data || !json.data.length) throw new Error('No result found for projection.');
                return json.data[0];
            });
    }

    function fetchPollsLatest(opts) {
        return fetchJson(API_BASE + '/polls?paginate=true&per_page=5')
            .then(function (json) {
                if (!json.data || !json.data.length) throw new Error('No polls found.');
                return json.data;
            });
    }

    var CHARTJS_CDN = 'https://cdn.jsdelivr.net/npm/chart.js@4/dist/chart.umd.min.js';

    var CHART_COLORS = {
        reform: '#26C6DA', lab: '#FF1744', con: '#1E88E5',
        lib: '#F6A800', snp: '#F2D232', green: '#5AD313',
        plaid: '#3F8428', other: '#BDBDBD'
    };

    function fetchResultsHistory(opts) {
        return fetchJson(API_BASE + '/results?simplified=true&legacy=false&model=' + encodeURIComponent(opts.model || CAPTURE_MODEL));
    }

    function ensureChartJS(cb) {
        if (window.Chart) { cb(); return; }
        var s = document.createElement('script');
        s.src = CHARTJS_CDN;
        s.onload = cb;
        document.head.appendChild(s);
    }

    function renderHistoryChart(data, mode, opts, onReady) {
        var root = document.querySelector('[data-capture-type]');
        var card = root && root.querySelector('.ukpr-ephemeral-card');
        if (!card) return;

        var pageTitle = mode === 'vote' ? 'Opinion Poll Trends' : 'Seat Projection Trends';
        var cardTitle = mode === 'vote' ? 'Vote Share' : 'Seat Projections';
        var suffix = mode === 'vote' ? '%' : '';

        titleEl.textContent = pageTitle;

        var labels = (data.labels || []).map(function (iso) {
            var d = new Date(iso);
            var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            return d.getDate() + ' ' + months[d.getMonth()];
        });

        var datasets = (data.datasets || []).map(function (ds) {
            return {
                label: ds.label,
                data: ds[mode] || [],
                borderColor: CHART_COLORS[ds.label] || '#999',
                backgroundColor: CHART_COLORS[ds.label] || '#999',
                borderWidth: 3,
                pointRadius: 0,
                tension: 0.3,
                fill: false
            };
        });

        // Build legend entries sorted by latest value desc, other last
        var entries = (data.datasets || []).map(function (ds) {
            var vals = ds[mode] || [];
            return { key: ds.label, val: vals[vals.length - 1] || 0 };
        });
        entries.sort(function (a, b) {
            if (a.key === 'other') return 1;
            if (b.key === 'other') return -1;
            return b.val - a.val;
        });

        var partyLabels = { con: 'CON', lab: 'LAB', lib: 'LD', snp: 'SNP', green: 'GRN', reform: 'REF', plaid: 'PC', other: 'OTH' };

        var legendHtml = entries.map(function (e) {
            var color = CHART_COLORS[e.key] || '#999';
            var lbl = partyLabels[e.key] || e.key.toUpperCase();
            var val = mode === 'vote' ? e.val.toFixed(1) + '%' : Math.round(e.val);
            return '<div class="ukpr-hc-legend-row">' +
                '<span class="ukpr-hc-dot" style="background:' + color + '"></span>' +
                '<span class="ukpr-hc-label">' + escHtml(lbl) + '</span>' +
                '<span class="ukpr-hc-val">' + escHtml(String(val)) + '</span>' +
                '</div>';
        }).join('');

        card.innerHTML =
            '<div class="ukpr-hc-header"><span class="ukpr-hc-title">' + escHtml(cardTitle) + '</span></div>' +
            '<div class="ukpr-hc-body">' +
                '<div class="ukpr-hc-chart-wrap"><canvas class="ukpr-hc-canvas"></canvas></div>' +
                '<div class="ukpr-hc-legend">' + legendHtml + '</div>' +
            '</div>' +
            buildInlineBrand(opts);

        ensureChartJS(function () {
            var canvas = card.querySelector('.ukpr-hc-canvas');
            if (!canvas) return;
            var ctx = canvas.getContext('2d');
        ensureChartJS(function () {
            var canvas = card.querySelector('.ukpr-hc-canvas');
            if (!canvas) return;
            var ctx = canvas.getContext('2d');
            new window.Chart(ctx, {
                type: 'line',
                data: { labels: labels, datasets: datasets },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: { duration: 0 },
                    plugins: {
                        legend: { display: false },
                        tooltip: { enabled: false }
                    },
                    scales: {
                        x: {
                            grid: { display: false },
                            ticks: { maxTicksLimit: 8, maxRotation: 0, color: 'rgba(128,128,128,0.8)', font: { size: 13 } }
                        },
                        y: {
                            position: 'right',
                            grid: { color: 'rgba(128,128,128,0.15)' },
                            ticks: {
                                color: 'rgba(128,128,128,0.8)',
                                font: { size: 13 },
                                callback: function (v) { return v + suffix; }
                            }
                        }
                    },
                    interaction: { mode: 'index', intersect: false }
                }
            });
            waitImagesAndSignal(cardEl);
            if (onReady) onReady();
        });
        });
    }

    function renderProjection(result, opts) {
        var boundaries = String(result.boundaries || opts.boundaries || '2024');
        var pollDate = (result.poll && result.poll.to) ? formatDateCompact(result.poll.to) : '';
        var winner = String((result.lead && result.lead.winner) || '').toLowerCase();

        // Build all-party seat data sorted by seats desc
        var seatData = PARTY_ORDER.map(function (key) {
            var party = result.parties && result.parties[key] ? result.parties[key] : null;
            return {
                key: key,
                label: PARTY_SHORT[key] || key.toUpperCase(),
                seats: party && party.seats ? Number(party.seats.prediction) : 0,
                vote: party && party.vote ? Number(party.vote.prediction) : 0
            };
        });
        seatData.sort(function (a, b) {
            if (a.key === 'other') return 1;
            if (b.key === 'other') return -1;
            return b.seats - a.seats;
        });
        seatData = seatData.filter(function (p) { return p.seats > 0; });

        // Pre-render trim
        var frameH = Math.round(opts.height * 0.97);
        var estRightH = frameH - 102;
        seatData = trimPartyData(seatData, estRightH, 2, winner ? [winner] : []);

        var totalSeats = seatData.reduce(function (sum, p) { return sum + p.seats; }, 0);
        var leadingParty = seatData[0] || { key: 'other', seats: 0, label: 'OTHER' };
        var leadingKey = leadingParty.key;
        var leadingLabel = PARTY_LABELS[leadingKey] || leadingParty.label || leadingKey.toUpperCase();
        var leadingSeats = Number(leadingParty.seats || 0);

        var topSeats = leadingSeats || 1;
        var railMax = Math.max(topSeats + 20, 350);
        var majorityPct = Math.min(100, (326 / railMax) * 100).toFixed(2);
        var avatarUrl, avatar, fillWidth;
        var majorityText = '';

        if (leadingSeats >= 326) {
            var othersTotal = Math.max(0, totalSeats - leadingSeats);
            var projectedMajority = Math.max(0, leadingSeats - othersTotal);
            majorityText = '<span class="party-' + escHtml(leadingKey) + '">' + escHtml(leadingLabel)
                + '</span> projected majority of <span class="party-' + escHtml(leadingKey) + '">'
                + escHtml(String(projectedMajority)) + '</span>';
        } else {
            var shortOfMajority = Math.max(0, 326 - leadingSeats);
            majorityText = '<span class="party-' + escHtml(leadingKey) + '">' + escHtml(leadingLabel)
                + '</span> <span class="party-' + escHtml(leadingKey) + '">'
                + escHtml(String(shortOfMajority)) + '</span> short of a majority';
        }

        var bars = seatData.map(function (party) {
            fillWidth = Math.max(0, Math.min(100, (party.seats / railMax) * 100));
            avatarUrl = PARTY_AVATAR_URLS[party.key] || '';
            avatar = avatarUrl
                ? '<img src="' + escHtml(avatarUrl) + '" alt="' + escHtml(party.label) + '" class="ukpr-result-bar-avatar-img">'
                : '<span class="ukpr-result-bar-avatar-fallback">' + escHtml(PARTY_SHORT[party.key] || party.label.toUpperCase()) + '</span>';
            return ''
                + '<div class="ukpr-result-bar-row">'
                + '<span class="ukpr-result-bar-avatar party-' + escHtml(party.key) + '">' + avatar + '</span>'
                + '<div class="ukpr-result-bar-track-wrap">'
                + '<div class="ukpr-result-bar-track">'
                + '<div class="ukpr-result-bar-fill party-' + escHtml(party.key) + '" style="width:' + escHtml(String(fillWidth)) + '%"></div>'
                + '</div>'
                + '<div class="ukpr-result-bar-majority" style="left:' + escHtml(String(majorityPct)) + '%"></div>'
                + '</div>'
                + '<span class="ukpr-result-bar-value party-' + escHtml(party.key) + '">'
                + escHtml(String(party.seats))
                + '<small>' + escHtml(party.vote.toFixed(1).replace(/\.0$/, '')) + '%</small>'
                + '</span>'
                + '</div>';
        }).join('');

        titleEl.textContent = '';
        metaEl.textContent = 'Type: projection | Model: ' + opts.model
            + ' | Boundaries: ' + boundaries
            + ' | Winner: ' + (PARTY_LABELS[winner] || winner.toUpperCase() || 'N/A')
            + ' | Poll: ' + pollDate;

        cardEl.innerHTML = ''
            + '<div class="ukpr-result-capture-layout">'
            + '<section class="ukpr-result-capture-left">'
            + '<p class="ukpr-result-capture-kicker">Live model update' + (pollDate ? ' — ' + escHtml(pollDate) : '') + '</p>'
            + '<h2 class="ukpr-result-capture-pollster">The race to 326</h2>'
            + '<p class="ukpr-proj-subheader">' + majorityText + '</p>'
            + buildInlineBrand(opts, ['326 seats for majority', 'Boundaries: ' + boundaries])
            + '</section>'
            + '<section class="ukpr-result-capture-right" aria-label="Race to 326 bar chart">'
            + bars
            + '</section>'
            + '</div>';

        requestAnimationFrame(function () {
            var rightPanel = cardEl.querySelector('.ukpr-result-capture-right');
            var pollsterEl = cardEl.querySelector('.ukpr-result-capture-pollster');
            var leftPanel = cardEl.querySelector('.ukpr-result-capture-left');
            fitBarPanel(rightPanel, seatData.length, { hasAvatar: true });
            fitTextToPanel(pollsterEl, leftPanel, 61, 24);
            waitImagesAndSignal(cardEl);
        });
    }

    function renderPollsLatest(polls, opts) {
        if (!polls || !polls.length) {
            setStateError('No polls available.');
            return;
        }

        // Use up to 5 polls
        var items = polls.slice(0, 5);

        // Build rows
        var rows = items.map(function (poll) {
            // Compute vote shares
            var partyData = PARTY_ORDER.map(function (key) {
                return { key: key, value: Number(poll[key] || 0) };
            }).filter(function (p) { return p.value > 0; });
            partyData.sort(function (a, b) { return b.value - a.value; });

            var total = partyData.reduce(function (s, p) { return s + p.value; }, 0);
            if (total < 1) total = 100;

            var pollsterName = (poll.pollster && poll.pollster.name) ? poll.pollster.name : 'Unknown';
            var clientName = (poll.client && poll.client.name) ? ' / ' + poll.client.name : '';
            var dateStr = formatDateRangeCompact(poll.from, poll.to);
            var winner = partyData[0] ? partyData[0].key : '';

            // Stacked segments
            var segs = partyData.map(function (p) {
                var pct = ((p.value / total) * 100).toFixed(3);
                var showPct = (p.value / total) >= 0.1;
                return '<div class="ukpr-polls-seg party-' + escHtml(p.key) + '" style="flex:' + escHtml(pct) + '">'
                    + (showPct ? '<span class="ukpr-polls-seg-label">' + escHtml(String(p.value)) + '%</span>' : '')
                    + '</div>';
            }).join('');

            return '<div class="ukpr-polls-row">'
                + '<div class="ukpr-polls-row-meta">'
                + '<span class="ukpr-polls-row-pollster">' + escHtml(pollsterName + clientName) + '</span>'
                + '<span class="ukpr-polls-row-date">' + escHtml(dateStr) + '</span>'
                + '<span class="ukpr-polls-row-winner party-' + escHtml(winner) + '">' + escHtml(PARTY_SHORT[winner] || winner.toUpperCase()) + ' lead</span>'
                + '</div>'
                + '<div class="ukpr-polls-bar">' + segs + '</div>'
                + '</div>';
        }).join('');

        titleEl.textContent = '';
        metaEl.textContent = 'Type: polls-latest | Count: ' + items.length + ' | Area: ' + (items[0] && items[0].area || 'GB');

        cardEl.innerHTML = ''
            + '<div class="ukpr-polls-latest-layout">'
            + '<header class="ukpr-polls-latest-header">'
            + '<h2 class="ukpr-polls-latest-title">Latest polls</h2>'
            + '<p class="ukpr-polls-latest-sub section-label">Westminster voting intention</p>'
            + '</header>'
            + '<div class="ukpr-polls-latest-body">' + rows + '</div>'
            + buildInlineBrand(opts)
            + '</div>';

        requestAnimationFrame(function () {
            waitImagesAndSignal(cardEl);
        });
    }

    function run() {
        var opts = parseRequestedState();
        root.setAttribute('data-capture-type', opts.type);

        var viewportEl = root.querySelector('[data-capture-viewport]');
        var frameEl = root.querySelector('[data-capture-frame]');
        var captureMetaEl = root.querySelector('[data-capture-meta]');
        var paramsEl = root.querySelector('[data-capture-params]');
        var modelEl = root.querySelector('[data-capture-model]');

        if (viewportEl) {
            viewportEl.style.width = opts.width + 'px';
            viewportEl.style.height = opts.height + 'px';
        }

        if (frameEl) {
            frameEl.style.width = Math.round(opts.width * 0.97) + 'px';
            frameEl.style.height = Math.round(opts.height * 0.97) + 'px';
        }

        if (captureMetaEl) {
            captureMetaEl.style.width = opts.width + 'px';
        }

        if (paramsEl) {
            paramsEl.textContent = JSON.stringify(opts, null, 2);
        }

        if (modelEl) {
            modelEl.textContent = buildModelText(opts);
            modelEl.hidden = opts.type === 'poll';
        }

        if (opts.type !== 'poll') {
            clearBrandLogoWidth();
        }

        setStateLoading();

        if (opts.type === 'seat' || opts.type === 'map') {
            fetchSeat(opts)
                .then(function (seat) {
                    renderSeat(seat, opts);
                    setStateReady();
                })
                .catch(function (err) {
                    setStateError(err.message || 'Failed to render seat capture.');
                });
            return;
        }

        if (opts.type === 'poll') {
            fetchPoll(opts)
                .then(function (poll) {
                    renderPoll(poll, opts);
                    setStateReady();
                })
                .catch(function (err) {
                    setStateError(err.message || 'Failed to render poll capture.');
                });
            return;
        }

        if (opts.type === 'result') {
            fetchProjection(opts)
                .then(function (result) {
                    renderProjection(result, opts);
                    setStateReady();
                })
                .catch(function (err) {
                    setStateError(err.message || 'Failed to render projection capture.');
                });
            return;
        }

        if (opts.type === 'projection') {
            fetchProjection(opts)
                .then(function (result) {
                    renderProjection(result, opts);
                    setStateReady();
                })
                .catch(function (err) {
                    setStateError(err.message || 'Failed to render projection capture.');
                });
            return;
        }

        if (opts.type === 'polls-latest') {
            fetchPollsLatest(opts)
                .then(function (polls) {
                    renderPollsLatest(polls, opts);
                    setStateReady();
                })
                .catch(function (err) {
                    setStateError(err.message || 'Failed to render polls-latest capture.');
                });
            return;
        }

        if (opts.type === 'polls-chart' || opts.type === 'seats-chart') {
            var chartMode = opts.type === 'polls-chart' ? 'vote' : 'seats';
            fetchResultsHistory(opts)
                .then(function (json) {
                    return new Promise(function (resolve, reject) {
                        try {
                            renderHistoryChart(json.data, chartMode, opts, resolve);
                        } catch (e) { reject(e); }
                    });
                })
                .then(function () { setStateReady(); })
                .catch(function (err) {
                    setStateError(err.message || 'Failed to render chart capture.');
                });
            return;
        }

        Promise.all([fetchParty(opts), fetchResult(opts)])
            .then(function (results) {
                renderParty(results[0], results[1], opts);
                setStateReady();
            })
            .catch(function (err) {
                setStateError(err.message || 'Failed to render party capture.');
            });
    }

    run();
})();
